/* ============
 * Mutations for the alert module
 * ============
 *
 * The mutations that are available on the
 * alert module.
 */
import types from './mutation-types';

export default {
  [types.FETCH_ALERTS](state) {
    state.alertsLoading = true;
    state.resolvedAlertId = '';
  },
  [types.FETCH_ALERTS_SUCCESS](state, res) {
    state.alertsLoading = false;
    state.alerts = res.alerts;
    state.totalCount = res.totalCount;
    state.alertCount = res.alertCount;
  },
  [types.FETCH_ALERTS_FAIL](state, error) {
    state.alertsLoading = false;
    state.error = error;
  },
  [types.UPDATE_ALERT](state) {
    state.loading = true;
  },
  [types.UPDATE_ALERT_SUCCESS](state, response) {
    state.loading = false;
    state.user = response;
  },
  [types.UPDATE_ALERT_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },
  [types.RESOLVE_ALERT](state) {
    state.isResolutionLoading = true;
  },
  [types.RESOLVE_ALERT_SUCCESS](state, response) {
    state.isResolutionLoading = false;
    state.resolvedAlertId = response.resolved_alert_id;
  },
  [types.RESOLVE_ALERT_FAIL](state, error) {
    state.isResolutionLoading = false;
    state.resolvedAlertId = '';
    state.error = error;
  },
  [types.SET_ALERTS](state, alerts) {
    state.alerts = alerts;
  },
  [types.PERSIST_ALERT](state, { index, value }) {
    state.alerts[index] = { ...state.alerts[index], ...value };
    state.alerts = [...state.alerts];
  },
  [types.FETCH_RESOLVED_NOTES](state) {
    state.isResolutionLoading = true;
  },
  [types.FETCH_RESOLVED_NOTES_SUCCESS](state, res) {
    state.isResolutionLoading = false;
    state.resolvedNotes = res;
    state.errorMessage = '';
  },
  [types.FETCH_RESOLVED_NOTES_FAIL](state, error) {
    state.isResolutionLoading = false;
    state.resolvedNotes = [];
    state.errorMessage = error.error.message;
  }
};
